const STORAGE_KEY = 'du-cart-consent';
const CHECKBOX_SEL = '[data-du-cart-consent]';
const BUTTON_SEL = '[data-du-cart-checkout]';
const TERMS_SEL = '.du-cart-checkout-terms';

function isConsentGiven() {
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === '1') return true;
  } catch {
    /* private mode */
  }
  const box = document.querySelector(CHECKBOX_SEL);
  return Boolean(box?.checked);
}

function storeConsent(checked) {
  try {
    sessionStorage.setItem(STORAGE_KEY, checked ? '1' : '0');
  } catch {
    /* private mode */
  }
}

function applyConsentState() {
  const checked = isConsentGiven();

  document.querySelectorAll(CHECKBOX_SEL).forEach((input) => {
    if (input instanceof HTMLInputElement && input.checked !== checked) {
      input.checked = checked;
    }
  });

  document.querySelectorAll(BUTTON_SEL).forEach((button) => {
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.disabled) {
      button.removeAttribute('aria-disabled');
      button.classList.remove('is-du-consent-blocked');
      return;
    }
    button.setAttribute('aria-disabled', checked ? 'false' : 'true');
    button.classList.toggle('is-du-consent-blocked', !checked);
  });

  if (checked) {
    document.querySelectorAll(TERMS_SEL).forEach((el) => {
      el.classList.remove('is-du-consent-needed');
    });
  }
}

function markConsentNeeded() {
  const terms = document.querySelector(`${TERMS_SEL}:not([hidden])`) || document.querySelector(TERMS_SEL);
  terms?.classList.add('is-du-consent-needed');
  const box = document.querySelector(CHECKBOX_SEL);
  if (box instanceof HTMLInputElement) box.focus();
}

document.addEventListener(
  'change',
  (event) => {
    const target = event.target;
    if (!(target instanceof HTMLInputElement) || !target.matches(CHECKBOX_SEL)) return;
    storeConsent(target.checked);
    applyConsentState();
  },
  true
);

document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest(BUTTON_SEL);
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.disabled || button.getAttribute('aria-disabled') !== 'true') return;
    event.preventDefault();
    event.stopPropagation();
    markConsentNeeded();
  },
  true
);

document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.id !== 'cart-form') return;
    if (isConsentGiven()) return;
    event.preventDefault();
    applyConsentState();
    markConsentNeeded();
  },
  true
);

let applyQueued = false;
function queueApply() {
  if (applyQueued) return;
  applyQueued = true;
  requestAnimationFrame(() => {
    applyQueued = false;
    applyConsentState();
  });
}

const observer = new MutationObserver((records) => {
  for (const record of records) {
    for (const node of record.addedNodes) {
      if (!(node instanceof Element)) continue;
      if (node.matches(CHECKBOX_SEL) || node.matches(BUTTON_SEL) || node.querySelector(CHECKBOX_SEL) || node.querySelector(BUTTON_SEL)) {
        queueApply();
        return;
      }
    }
  }
});

function boot() {
  applyConsentState();
  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
